import * as React from 'react';
import Grid from "@mui/material/Grid2"
import { Box } from "@mui/system"
import dayjs from "dayjs"
import UserAvatar from "../UserAvatar";
import Viewer from 'react-viewer';

export default function RentalNote({ rentalNote }) {
    const [imageModalVisible, setImageModalVisible] = React.useState(false)

    return (<Box key={rentalNote.id} sx={{ mb: 1 }}>
        <Grid container space={1}>
            <Grid xs="auto">
                <span style={{ 'fontSize': '20px' }}><b>{dayjs.utc(rentalNote.date_created).local().format('M/D/YYYY h:mm A')} by {rentalNote.user.name}</b></span>
            </Grid>
            <Grid xs="auto" sx={{ pr: 2, pl: 2 }}>
                <UserAvatar user={rentalNote.user} />
            </Grid>
        </Grid>
        <Box sx={{ 'white-space': 'pre', m: 1, p: 1, backgroundColor: 'rgba(230, 230, 230, 1)', borderRadius: 2, boxShadow: 3 }}>
            <span>{rentalNote.text}</span>
        </Box>
        {rentalNote.image_path &&
            <Box>
                <Box
                    component="img"
                    alt={"Rental Note Image"}
                    src={`/customerimages/client/${rentalNote.client_id}/rentalnotes/${rentalNote.id}/${rentalNote.image_path}`}
                    sx={{
                        p: 1,
                        border: '1px solid grey',
                        borderRadius: 1,
                        "&:hover":
                        {
                            cursor: 'pointer',
                            opacity: 0.7,
                            transition: 'opacity 0.5s ease'
                        },
                        maxWidth: '150px',
                        maxHeight: '150px'
                    }}
                    onClick={() => setImageModalVisible(true)}
                />
                <Viewer
                    visible={imageModalVisible}
                    onClose={() => setImageModalVisible(false)}
                    images={[{ src: `/customerimages/client/${rentalNote.client_id}/rentalnotes/${rentalNote.id}/${rentalNote.image_path}`, alt: "Rental Note Image" }]}
                    drag={false}
                    zoomable={false}
                    rotatable={false}
                    scalable={false}
                    changeable={false}
                    zIndex={1200}
                />
            </Box>
        }
    </Box>)
}